<template>
  <div>
    <div class="conent">
      <el-form >
        <el-form-item label="申请人">
          <div>{{ info.name }}</div>
        </el-form-item>
        <el-form-item label="申请人手机">
          <div>{{ info.mobile }}</div>
        </el-form-item>
        <el-form-item label="专车类型">
          <div>{{ info.car_type_name }}</div>
        </el-form-item>
        <el-form-item label="驾驶证">
          <div class="images" v-viewer="{ movable: false }">
            <img
              style="width: 100px;height: 100px;border-radius: 10px;margin-top: 10px;cursor: pointer"
              :src="info.url"
            />
          </div>
        </el-form-item>
        <el-form-item label="审核状态">
          <el-tag
            v-text="
              info.status == 0
                ? '待审核'
                : info.status == 1
                ? '审核通过'
                : '审核拒绝'
            "
            :type="
              info.status == 0
                ? 'warning'
                : info.status == 1
                ? 'success'
                : 'danger'
            "
          ></el-tag>
        </el-form-item>
        <el-form-item label="创建时间">
          <div>{{ info.create_time | dataFormat }}</div>
        </el-form-item>
        <el-form-item>
          <el-button @click="back" style="margin-right: 20px">返 回</el-button>
          <span v-if="info.status == 0">
            <el-button type="success" @click="Audit(1)">审核通过</el-button>
            <el-button type="danger" @click="Audit(2)">审核拒绝</el-button>
          </span>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { RZaudit, RZdetail } from "@/api/carRZ";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["app_id"])
  },
  data() {
    return {
      info: {},
    };
  },
  mounted() {
    this.getdata();
  },
  methods: {
    async getdata() {
      const res = await RZdetail({
        app_id: this.app_id,
        id: this.$route.query.id
      });
      this.info = res.data;
    },
    back() {
      this.$router.go(-1);
    },
    //审核
    async Audit(val){
      let data={
        app_id:this.app_id,
        id:this.info.id,
        status:val
      }
      const res = await RZaudit(data)
      if(res.code == 200){
        this.$message.success(res.msg)
        this.getdata()
      }else {
        this.$message.error(res.msg)
      }
    }
  }
};
</script>

<style scoped>
.conent {
  margin: 40px auto;
  width: 50%;
}
</style>
